// extracted by mini-css-extract-plugin
export default {"content":"order_content__6AU9I","banner":"order_banner__mjK9W","title":"order_title__8X0Sl","text":"order_text__eBgVD"};